import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/AuthContext';
import { configError } from './lib/supabase';
import { Spinner } from './components/Shared';
import Icon from './components/Icon';

import AuthScreen from './screens/AuthScreen';
import GroupsScreen from './screens/GroupsScreen';
import GroupLayout from './screens/GroupLayout';
import SquadScreen from './screens/SquadScreen';
import BalanceScreen from './screens/BalanceScreen';
import LogScreen from './screens/LogScreen';
import HistoryScreen from './screens/HistoryScreen';
import PlayerScreen from './screens/PlayerScreen';

function RequireAuth({ children }) {
  const { session, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Spinner label="Checking your session…" />;
  if (!session) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

function SetupNotice() {
  return (
    <div className="setup-notice">
      <Icon name="alert" size={28} />
      <h1>Almost there</h1>
      <p>{configError}</p>
      <pre>
{`cp .env.example .env
# paste your URL + anon key from
# Supabase → Project Settings → API
npm run dev`}
      </pre>
    </div>
  );
}

export default function App() {
  const { session, loading } = useAuth();

  if (configError) return <SetupNotice />;

  return (
    <Routes>
      <Route
        path="/login"
        element={loading ? <Spinner /> : session ? <Navigate to="/groups" replace /> : <AuthScreen />}
      />
      <Route
        path="/groups"
        element={
          <RequireAuth>
            <GroupsScreen />
          </RequireAuth>
        }
      />
      <Route
        path="/g/:groupId"
        element={
          <RequireAuth>
            <GroupLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="squad" replace />} />
        <Route path="squad" element={<SquadScreen />} />
        <Route path="balance" element={<BalanceScreen />} />
        <Route path="log" element={<LogScreen />} />
        <Route path="history" element={<HistoryScreen />} />
        <Route path="player/:memberId" element={<PlayerScreen />} />
      </Route>
      <Route path="*" element={<Navigate to={session ? '/groups' : '/login'} replace />} />
    </Routes>
  );
}
